// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3o4eg","upload":"Small_upload__3bCJZ","imageWrap":"Small_imageWrap__bpFs8","removeBtn":"Small_removeBtn__16ne_"};